@if (dataSource$ | async; as dataSource) {
  <table mat-table [dataSource]="dataSource">
    <ng-container matColumnDef="oldValue">
      <th mat-header-cell *matHeaderCellDef>
        {{
          'raw-data.fields.OLD_VALUE' | transloco
        }}
      </th>
      <td mat-cell *matCellDef="let element">{{ element.oldValue | number: '.0-2'  }}</td>
    </ng-container>
    <ng-container matColumnDef="newValue">
      <th mat-header-cell *matHeaderCellDef>
        {{
          'raw-data.fields.NEW_VALUE' | transloco
        }}
      </th>
      <td mat-cell *matCellDef="let element">{{ element.newValue | number: '.0-2' }}</td>
    </ng-container>
    <ng-container matColumnDef="updatedBy">
      <th mat-header-cell *matHeaderCellDef>
        {{
          'raw-data.fields.UPDATED_BY' | transloco
        }}
      </th>
      <td mat-cell *matCellDef="let element">
        {{ element.updatedByDec.fullName }}
      </td>
    </ng-container>
    <ng-container matColumnDef="updatedDate">
      <th mat-header-cell *matHeaderCellDef>
        {{
          'raw-data.fields.UPDATED_DATE' | transloco
        }}
      </th>
      <td mat-cell *matCellDef="let element">
        {{ element.updatedDate | date: 'shortDate' }}
      </td>
    </ng-container>
    <ng-container *matNoDataRow>
      <td class="mat-cell" colspan="4">
        {{
          'raw-data.info.NO_DATA' | transloco
        }}
      </td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>
}
